var _g, _g2, _g3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDbBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 111,
    viewBox: "0 0 102 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.550799
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 101.978C39.2091 101.978 41 103.769 41 105.978C41 108.187 39.2091 109.978 37 109.978C34.7909 109.978 33 108.187 33 105.978C33 103.769 34.7909 101.978 37 101.978Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 101.978C39.2091 101.978 41 103.769 41 105.978C41 108.187 39.2091 109.978 37 109.978C34.7909 109.978 33 108.187 33 105.978C33 103.769 34.7909 101.978 37 101.978Z",
    stroke: "#E5E7EB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.500291
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 101.978C53.2091 101.978 55 103.769 55 105.978C55 108.187 53.2091 109.978 51 109.978C48.7909 109.978 47 108.187 47 105.978C47 103.769 48.7909 101.978 51 101.978Z",
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 101.978C53.2091 101.978 55 103.769 55 105.978C55 108.187 53.2091 109.978 51 109.978C48.7909 109.978 47 108.187 47 105.978C47 103.769 48.7909 101.978 51 101.978Z",
    stroke: "#E5E7EB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.529933
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 101.978C67.2091 101.978 69 103.769 69 105.978C69 108.187 67.2091 109.978 65 109.978C62.7909 109.978 61 108.187 61 105.978C61 103.769 62.7909 101.978 65 101.978Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 101.978C67.2091 101.978 69 103.769 69 105.978C69 108.187 67.2091 109.978 65 109.978C62.7909 109.978 61 108.187 61 105.978C61 103.769 62.7909 101.978 65 101.978Z",
    stroke: "#E5E7EB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6562 9.19022H65.3438C66.2203 9.19022 66.9375 9.87948 66.9375 10.7219V18.3804H35.0625V10.7219C35.0625 9.87948 35.7797 9.19022 36.6562 9.19022ZM25.5 10.7219V18.3804H12.75C5.71758 18.3804 0 23.8754 0 30.6341V49.0145H38.25H63.75H102V30.6341C102 23.8754 96.2824 18.3804 89.25 18.3804H76.5V10.7219C76.5 4.80572 71.4996 0 65.3438 0H36.6562C30.5004 0 25.5 4.80572 25.5 10.7219ZM102 55.1413H63.75V61.2681C63.75 64.657 60.9012 67.3949 57.375 67.3949H44.625C41.0988 67.3949 38.25 64.657 38.25 61.2681V55.1413H0V79.6486C0 86.4072 5.71758 91.9022 12.75 91.9022H89.25C96.2824 91.9022 102 86.4072 102 79.6486V55.1413Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbBox);
export default __webpack_public_path__ + "static/media/db-box.02a997f53ec802369f4f20d530637f01.svg";
export { ForwardRef as ReactComponent };